/**
 * Servicio de almacenamiento local para favoritos y configuración
 */

const STORAGE_KEYS = {
  FAVORITOS: 'datacultivo_favoritos',
  CONFIG: 'datacultivo_config',
  ONBOARDING: 'datacultivo_onboarding_completado'
};

const DEFAULT_FAVORITOS = {
  estacionId: null,
  estacionNombre: null,
  comarcaVina: null,
  comarcaPapa: null,
  productoFavorito: null,
  anioDefecto: new Date().getFullYear()
};

const DEFAULT_CONFIG = {
  modoAhorroDatos: false
};

/**
 * Obtener favoritos del localStorage
 */
export function getFavoritos() {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.FAVORITOS);
    if (stored) {
      return { ...DEFAULT_FAVORITOS, ...JSON.parse(stored) };
    }
    return DEFAULT_FAVORITOS;
  } catch (e) {
    console.error('Error leyendo favoritos:', e);
    return DEFAULT_FAVORITOS;
  }
}

/**
 * Guardar favoritos en localStorage
 */
export function saveFavoritos(favoritos) {
  try {
    const current = getFavoritos();
    const updated = { ...current, ...favoritos };
    localStorage.setItem(STORAGE_KEYS.FAVORITOS, JSON.stringify(updated));
    return updated;
  } catch (e) {
    console.error('Error guardando favoritos:', e);
    throw e;
  }
}

/**
 * Obtener configuración
 */
export function getConfig() {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.CONFIG);
    if (stored) {
      return { ...DEFAULT_CONFIG, ...JSON.parse(stored) };
    }
    return DEFAULT_CONFIG;
  } catch (e) {
    console.error('Error leyendo config:', e);
    return DEFAULT_CONFIG;
  }
}

/**
 * Guardar configuración
 */
export function saveConfig(config) {
  try {
    const current = getConfig();
    const updated = { ...current, ...config };
    localStorage.setItem(STORAGE_KEYS.CONFIG, JSON.stringify(updated));
    return updated;
  } catch (e) {
    console.error('Error guardando config:', e);
    throw e;
  }
}

/**
 * Verificar si el onboarding está completado
 */
export function isOnboardingCompleted() {
  return localStorage.getItem(STORAGE_KEYS.ONBOARDING) === 'true';
}

/**
 * Marcar onboarding como completado
 */
export function completeOnboarding() {
  localStorage.setItem(STORAGE_KEYS.ONBOARDING, 'true');
}

/**
 * Resetear onboarding
 */
export function resetOnboarding() {
  localStorage.removeItem(STORAGE_KEYS.ONBOARDING);
}

/**
 * Limpiar todo el almacenamiento de la app
 */
export function clearAllStorage() {
  Object.values(STORAGE_KEYS).forEach(key => {
    localStorage.removeItem(key);
  });
}

export default {
  getFavoritos,
  saveFavoritos,
  getConfig,
  saveConfig,
  isOnboardingCompleted,
  completeOnboarding,
  resetOnboarding,
  clearAllStorage
};
